module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "login",
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "login-desc"
  }), _c('div', {
    staticClass: "login-container"
  }, [_c('div', {
    staticClass: "login-form-wrapper",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    }
  }, [_vm._m(0), _c('form', {
    staticClass: "login-form"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "login-account"
    }
  }, [_vm._v("账号 ")]), _c('div', {
    staticClass: "input-group",
    class: _vm.isFocus === 1 ? 'input-group-active' : ''
  }, [_c('i', {
    staticClass: "icon iconfont icon-account",
    class: _vm.isFocus === 1 ? 'icon-active' : ''
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.username),
      expression: "form.username"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "login-account",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.form.username)
    },
    on: {
      "focus": function($event) {
        _vm.focusEvent(1)
      },
      "blur": function($event) {
        _vm.focusEvent(0)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "username", $event.target.value)
      }
    }
  })]), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "login-password"
    }
  }, [_vm._v("密码 ")]), _c('div', {
    staticClass: "input-group",
    class: _vm.isFocus === 2 ? 'input-group-active' : ''
  }, [_c('i', {
    staticClass: "icon iconfont icon-password",
    class: _vm.isFocus === 2 ? 'icon-active' : ''
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "id": "login-password",
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "focus": function($event) {
        _vm.focusEvent(2)
      },
      "blur": function($event) {
        _vm.focusEvent(0)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  })]), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), (_vm.checkStatus()) ? _c('div', {
    attrs: {
      "title": "是否显示滚动验证"
    }
  }, [_c('drag-verify', {
    ref: "Verify",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "text": _vm.text,
      "success-text": _vm.successText,
      "background": _vm.background,
      "progress-bar-bg": _vm.progressBarBg,
      "completed-bg": _vm.completedBg,
      "handler-bg": _vm.handlerBg,
      "handler-icon": _vm.handlerIcon,
      "text-size": _vm.textSize,
      "success-icon": _vm.successIcon
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "btn btn-lg btn-complete btn-blocks btn-blocks-left",
    class: {
      'disabled-left': _vm.buttonDisabled
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("立 即 登 录")]), _c('div', {
    staticClass: "btn btn-lg btn-complete btn-blocks btn-blocks-right register",
    class: {
      'disabled-right': _vm.buttonDisabled
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = true
      }
    }
  }, [_vm._v("注册 ")]), _c('el-dialog', {
    attrs: {
      "title": "注册账号",
      "visible": _vm.dialogFormVisible,
      "modal-append-to-body": false,
      "show-close": false,
      "width": "200px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "授权码",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px",
      "float": "left"
    },
    attrs: {
      "placeholder": "请输入授权码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.authcode),
      callback: function($$v) {
        _vm.$set(_vm.form2, "authcode", $$v)
      },
      expression: "form2.authcode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px",
      "float": "left"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getRoleProof()
      }
    }
  }, [_vm._v("获取授权码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "placeholder": "请输入您想要的用户名",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.name),
      callback: function($$v) {
        _vm.$set(_vm.form2, "name", $$v)
      },
      expression: "form2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.password1),
      callback: function($$v) {
        _vm.$set(_vm.form2, "password1", $$v)
      },
      expression: "form2.password1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "410px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请再次输入密码",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.password2),
      callback: function($$v) {
        _vm.$set(_vm.form2, "password2", $$v)
      },
      expression: "form2.password2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.form2.state
    },
    on: {
      "click": function($event) {
        _vm.toregister()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1), _c('el-dialog', {
    attrs: {
      "title": "完善公司信息",
      "visible": _vm.dialogTableVisible,
      "modal-append-to-body": false,
      "show-close": false,
      "width": "200px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogTableVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司全称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px",
      "float": "left"
    },
    attrs: {
      "placeholder": "请您输入公司名称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.orgname1),
      callback: function($$v) {
        _vm.$set(_vm.form3, "orgname1", $$v)
      },
      expression: "form3.orgname1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司简称",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px"
    },
    attrs: {
      "placeholder": "再输入公司的简称",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.orgname2),
      callback: function($$v) {
        _vm.$set(_vm.form3, "orgname2", $$v)
      },
      expression: "form3.orgname2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司logo",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "placeholder": "请在此放入logo图片地址，或点击右边小按钮",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.orglogo),
      callback: function($$v) {
        _vm.$set(_vm.form3, "orglogo", $$v)
      },
      expression: "form3.orglogo"
    }
  }), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "二级域名",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "370px"
    },
    attrs: {
      "type": "text",
      "placeholder": "放入您公司官网的URL",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form3.orgurl),
      callback: function($$v) {
        _vm.$set(_vm.form3, "orgurl", $$v)
      },
      expression: "form3.orgurl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "420px",
      "line-height": "23px"
    },
    attrs: {
      "type": "textarea",
      "placeholder": "备注信息",
      "auto-complete": "off",
      "autosize": true,
      "maxlength": 60
    },
    model: {
      value: (_vm.form3.orgremark),
      callback: function($$v) {
        _vm.$set(_vm.form3, "orgremark", $$v)
      },
      expression: "form3.orgremark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogTableVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.form3.state
    },
    on: {
      "click": function($event) {
        _vm.perfectOrg()
      }
    }
  }, [_vm._v("提 交")])], 1)], 1)], 1)]), _c('div', {
    staticClass: "version-wrapper"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.copyright))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    staticClass: "logo_title"
  }, [_vm._v("欢迎登陆")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-247f2ae2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Login/index.vue
// module id = 1720
// module chunks = 1